import React from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const ServerDown: React.FC = () => (
  <Box
    sx={{
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      bgcolor: "background.default",
      textAlign: "center",
      px: 2,
    }}
  >
    <Paper elevation={4} sx={{ p: 4, borderRadius: 4, maxWidth: 420 }}>
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Typography variant="h2" color="error" fontWeight={700} sx={{ mb: 1 }}>
          500
        </Typography>
        <ErrorOutlineIcon color="error" sx={{ fontSize: 60, mb: 2 }} />
        <Typography variant="h5" fontWeight={600} sx={{ mb: 2 }}>
          Internal Server Error
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
          The server is currently unavailable.<br />
          <b>Possible reasons:</b>
          <ul style={{ textAlign: "left", margin: "8px auto 0", paddingLeft: 24, maxWidth: 320 }}>
            <li>Server maintenance or upgrade</li>
            <li>Unexpected crash or overload</li>
            <li>Network or gateway issues</li>
          </ul>
          Please try again later or contact support if the issue persists.
        </Typography>
        <Button variant="contained" color="primary" onClick={() => window.location.reload()}>
          Retry
        </Button>
      </Box>
    </Paper>
  </Box>
);

export default ServerDown;